import Rectangle from "./Rectangle";
import Length from "./Length";
import AbstractShape from "./AbstractShape";
import Area from "./Area";
import Parallelogram from "./Parallelogram";

export default class AbstractParallelogram extends AbstractShape {

	constructor( width, height ) {
		super();

		this.width = width;
		this.height = height;
	}

	get_enclosing_rectangle() {
		return new Rectangle( this.get_enclosing_width(), this.height );
	}

	get_area() {
		const width = this.width.in_mm();
		const height = this.height.in_mm();

		return new Area( width * height );
	}

	get_circumference() {
		const width = this.width.in_mm();
		const height = this.height.in_mm();
		const angleInRadians = ( 60 * Math.PI ) / 180; // Convert angle to radians
		const slopedSide = height / Math.sin( angleInRadians );

		const circumference = 2 * width + 2 * slopedSide;
		return new Length( circumference );
	}

	get_width() {
		return this.width;
	}

	get_enclosing_width() {
		return Length.from_mm( this.width.in_mm() + this.get_slanted_width().in_mm() );
	}

	get_slanted_width() {
		const angleRadians = 60 * Math.PI / 180;
		const slantHeight = this.height.in_mm() / Math.sin( angleRadians );
		const width = slantHeight * Math.cos( angleRadians );

		return Length.from_mm( width );
	}

	get_height() {
		return this.height;
	}

	get_maximum_dimensions( maximum_rectangle ) {
		return {
			width: maximum_rectangle.get_longest_side(),
			height: maximum_rectangle.get_shortest_side()
		};
	}

	get_dimension_keys() {
		return [ "width", "height" ];
	}

	get_modifier_keys() {
		return [];
	}

	serialize_primitives() {
		return {
			width: this.width.in_mm(),
			height: this.height.in_mm()
		};
	}

	static deserialize_primitives( primitives ) {
		return new Parallelogram( new Length( primitives.width ), new Length( primitives.height ) );
	}
}
